import React, { useEffect, useState } from "react"

// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import { AdminHeader } from "shared/components/common/AdminHeader"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import { selectAuth } from "shared/redux/slices/authSlice"

import { useNavigate } from "react-router-dom"

import {
  Alert,
  Card,
  CardContent,
  CardHeader,
  Chip,
  InputAdornment,
  Snackbar,
  Tooltip,
} from "@mui/material"
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DataTable from "components/DataTable"
import MDSelect from "components/MDSelect"
import MDInput from "components/MDInput"

import { Loading } from "shared/components/ui/Loading"

// Icon
import CustomEyeIcon from "components/icons/CustomEyeIcon"
import CustomApproveIcon from "components/icons/CustomApproveIcon"
import CustomRejectIcon from "components/icons/CustomRejectIcon"
import ModalApproveLeave from "components/ModalApproveLeave/ModalApproveLeave"
import ModalReasonDenyLeave from "components/ModalReasonDenyLeave/ModalReasonDenyLeave"

// Redux
import { useLazyGetLeaveLXOV3Query } from "shared/redux/endpoints/lxo"
import {
  useApproveLeaveRequestAdminMutation,
  useRejectLeaveRequestAdminMutation,
} from "shared/redux/endpoints/employee"
import moment from "moment"
import ReactPaginate from "react-paginate"
import DateSelect from "components/DateSelect/temp3"
import { enUS } from "date-fns/locale"

import "./LeaveRequestType.scss"
import { Search as SearchIcon } from "lucide-react"
import { useSelector } from "react-redux"

const DATE_FORMAT = "DD/MM/YYYY HH:mm"

export const LeaveRequestType = () => {
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD")
  const endOfRange = moment()
    .startOf("month")
    .add(60, "days")
    .format("YYYY-MM-DD")

  const [isLoading, setIsLoading] = useState(true)
  const [dataTable, setDataTable] = useState({
    columns: [
      { Header: "No", accessor: "no", width: "80px" },
      { Header: "Teacher name", accessor: "teacherName", width: "200px" },
      { Header: "Leave Type", accessor: "leaveType", width: "150px" },
      { Header: "Submit Date", accessor: "submitDate", width: "150px" },
      { Header: "Start date", accessor: "startDate", width: "150px" },
      { Header: "End date", accessor: "endDate", width: "150px" },
      {
        Header: "Total Leave Number",
        accessor: "totalLeaveNumber",
        width: "180px",
      },
      { Header: "Status", accessor: "status", width: "120px" },
      { Header: "Action", accessor: "action", width: "120px" },
    ],
    rows: [],
  })

  const navigate = useNavigate()
  const auth = useSelector(selectAuth)
  const centerId = auth?.centerId

  const [pagination, setPagination] = useState({
    currentPage: 0,
    pageSize: 5,
    totalPage: 0,
    totalElement: 0,
    order: {
      column: "id",
      direction: "asc",
    },
  })

  const [state, setState] = useState({
    page: pagination.currentPage,
    size: pagination.pageSize,
    search: "",
    leaveType: "",
    status: "",
    startDate: startOfMonth,
    endDate: endOfRange,
    order: `${pagination.order.column},${pagination.order.direction}`,
    centerId,
  })

  const [triggerLeaveRequest] = useLazyGetLeaveLXOV3Query()
  const [approveLeaveRequest] = useApproveLeaveRequestAdminMutation()
  const [rejectLeaveRequest] = useRejectLeaveRequestAdminMutation()
  const [isOpenApproveModal, setIsOpenApproveModal] = useState(false)
  const [isOpenRejectModal, setIsOpenRejectModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  })

  const fetchOptions = async (params) => {
    setIsLoading(true)
    await triggerLeaveRequest(params)
      .then((res) => handleDataTable(res?.data))
      .finally(() => setIsLoading(false))
  }

  const handleDataTable = (response) => {
    const data = response?.data?.data || []
    console.log(response)

    const display = (value) =>
      value === null || value === undefined || value === "" ? "-" : value

    setDataTable({
      ...dataTable,
      rows:
        data?.map((item) => {
          const labelLowerCase = String(item.status || "").toLowerCase()
          return {
            no: <MDTypography>{display(item.leaveRequestId)}</MDTypography>,
            teacherName: (
              <div className="avatar-wrapper">
                <MDTypography className="name">
                  {display(item.employeeFullName)}
                </MDTypography>
              </div>
            ),
            leaveType: <MDTypography>{display(item.leaveType)}</MDTypography>,
            submitDate: (
              <MDTypography>
                {item.createdAt
                  ? moment(item.createdAt).format(DATE_FORMAT)
                  : "-"}
              </MDTypography>
            ),
            startDate: (
              <MDTypography>
                {item.startDate
                  ? moment(item.startDate).format(DATE_FORMAT)
                  : "-"}
              </MDTypography>
            ),
            endDate: (
              <MDTypography>
                {item.endDate ? moment(item.endDate).format(DATE_FORMAT) : "-"}
              </MDTypography>
            ),
            totalLeaveNumber: (
              <MDTypography>
                {display(item.totalDays)} {item.totalDays > 1 ? "days" : "day"}
              </MDTypography>
            ),
            status: item.status ? (
              <MDTypography
                className={`chip-status chip-status-${labelLowerCase}`}
              >
                {item.status.toLowerCase()}
              </MDTypography>
            ) : (
              <MDTypography>-</MDTypography>
            ),
            action: (
              <div className="action-wrap">
                <Tooltip title={`Update`} enterDelay={2000}>
                  <div
                    onClick={() => {
                      handlerAction(item, "update")
                    }}
                  >
                    <CustomEyeIcon />
                  </div>
                </Tooltip>
                <Tooltip title={`Approve`} enterDelay={2000}>
                  <div
                    onClick={() => {
                      handlerAction(item, "approve")
                    }}
                  >
                    <CustomApproveIcon />
                  </div>
                </Tooltip>
                <Tooltip title={`Reject`} enterDelay={2000}>
                  <div
                    onClick={() => {
                      handlerAction(item, "reject")
                    }}
                  >
                    <CustomRejectIcon />
                  </div>
                </Tooltip>
              </div>
            ),
          }
        }) || [],
    })

    setState({
      ...state,
      page: response?.data?.currentPage,
      size: response?.data?.pageSize,
    })
    setPagination({
      ...pagination,
      totalPage: response?.data?.totalPage,
      totalElement: response?.data?.totalElement,
      currentPage: response?.data?.currentPage,
    })
  }

  const handleAddNew = () => {
    alert("Add New")
  }

  const handleApprove = async (item) => {
    if (!item?.leaveRequestId) return
    try {
      await approveLeaveRequest(item.leaveRequestId).unwrap()
      setIsOpenApproveModal(true)
      fetchOptions(state)
    } catch (error) {
      setSnackbar({
        open: true,
        message:
          error?.data?.data?.message || "Approve failed. Please try again.",
        severity: "error",
      })
    }
  }

  const handleReject = async (reason) => {
    if (!selectedItem?.leaveRequestId) return
    try {
      await rejectLeaveRequest({
        id: selectedItem.leaveRequestId,
        rejectionReason: reason,
      }).unwrap()
      setIsOpenRejectModal(false)
      setSelectedItem(null)
      fetchOptions(state)
    } catch (error) {
      setSnackbar({
        open: true,
        message:
          error?.data?.data?.message || "Reject failed. Please try again.",
        severity: "error",
      })
    }
  }

  const handlerAction = (item, action) => {
    switch (action) {
      case "update":
        // navigate to detail page
        navigate(`/leave-request/leave-request-detail/${item.leaveRequestId}`)
        break
      case "approve":
        handleApprove(item)
        break
      case "reject":
        setSelectedItem(item)
        setIsOpenRejectModal(true)
        break
      default:
        break
    }
  }

  const optionsLeaveType = [
    { value: "", label: "All Types", name: "leaveType" },
    { value: "ANNUAL", label: "Annual Leave", name: "leaveType" },
    { value: "SICK", label: "Sick Leave", name: "leaveType" },
    { value: "UNPAID", label: "Unpaid Leave", name: "leaveType" },
  ]

  const optionsStatus = [
    { value: "", label: "All Status", name: "status" },
    { value: "APPROVED", label: "Approved", name: "status" },
    { value: "PENDING", label: "Pending", name: "status" },
    { value: "REJECTED", label: "Rejected", name: "status" },
    { value: "DRAFT", label: "Draft", name: "status" },
  ]

  const onChangeSelect = (option) => {
    if (!option?.name) return
    setState((prev) => ({
      ...prev,
      [option.name]: option.value,
      page: 0,
    }))
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setState((prev) => ({
      ...prev,
      [name]: value,
      page: 0,
    }))
  }

  const handleChangePage = (page) => {
    fetchOptions({
      ...state,
      page: page,
    })
  }

  useEffect(() => {
    fetchOptions(state)
  }, [])

  // debounce search fields + select filters (leaveType/status)
  useEffect(() => {
    const t = setTimeout(() => {
      fetchOptions({
        ...state,
        page: 0,
      })
    }, 500)
    return () => clearTimeout(t)
  }, [
    state.search,
    state.employeeName,
    state.leaveType,
    state.status,
    centerId,
  ])

  // date range: only trigger when both start/end exist
  useEffect(() => {
    if (!state.startDate || !state.endDate) return
    fetchOptions({
      ...state,
      page: 0,
    })
  }, [state.startDate, state.endDate])

  return (
    <DashboardLayout>
      <AdminHeader />
      <DashboardNavbar light />
      <MDBox className="admin-mgr-link-container">
        <Card>
          {isLoading && (
            <Loading
              style={{ width: 250, height: 200, margin: "150px auto" }}
            />
          )}
          {!isLoading && (
            <>
              <CardHeader className="card-header" title="Leave Request" />
              <MDBox
                display="flex"
                gap={2}
                mb={2}
                alignItems="center"
                flexWrap="wrap"
                p={2}
              >
                <MDInput
                  className="input input-search"
                  placeholder="Search"
                  name="search"
                  value={state.search}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="icon-search" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={handleInputChange}
                />

                <MDSelect
                  placeholder="Leave Type"
                  options={optionsLeaveType}
                  onChange={onChangeSelect}
                  name="leaveType"
                  value={optionsLeaveType.find(
                    (opt) => opt.value === state.leaveType
                  )}
                />

                <MDSelect
                  placeholder="Status"
                  options={optionsStatus}
                  onChange={onChangeSelect}
                  name="status"
                  value={optionsStatus.find(
                    (opt) => opt.value === state.status
                  )}
                />

                <DateSelect
                  onChangeStartDate={(e) =>
                    setState((prev) => ({
                      ...prev,
                      startDate: moment(e).format("YYYY-MM-DD"),
                      page: 0,
                    }))
                  }
                  onChangeEndDate={(e) =>
                    setState((prev) => ({
                      ...prev,
                      endDate: moment(e).format("YYYY-MM-DD"),
                      page: 0,
                    }))
                  }
                  defaultStartDate={state.startDate}
                  defaultEndDate={state.endDate}
                  locale={enUS}
                />
              </MDBox>
              <CardContent>
                <MDBox className="teacher-management__table">
                  <MDBox className="teacher-management__table-wrapper">
                    <DataTable
                      table={dataTable}
                      entriesPerPage={{
                        isShown: true,
                        defaultValue: state.size,
                        entries: [5, 10, 25],
                        pagination: true,
                      }}
                    />
                    <MDBox className="table-footer">
                      <MDBox className="table-footer-showing">
                        Showing {dataTable?.rows?.length} of{" "}
                        {dataTable?.rows?.length} entries
                      </MDBox>
                      {pagination.totalPage >= 0 && (
                        <ReactPaginate
                          className="pagination"
                          nextLabel={<Icon>chevron_right</Icon>}
                          previousLabel={<Icon>chevron_left</Icon>}
                          forcePage={Number(state.page)}
                          onPageChange={(event) => {
                            handleChangePage(event.selected)
                          }}
                          pageCount={pagination.totalPage}
                        />
                      )}
                    </MDBox>
                  </MDBox>
                </MDBox>
              </CardContent>
            </>
          )}
          {/* <DialogCreateOrUpdateLink {...propertiesModalCreateOrUpdateLink} /> */}
        </Card>
      </MDBox>
      <ModalApproveLeave
        isOpen={isOpenApproveModal}
        onClose={() => setIsOpenApproveModal(false)}
        onSubmit={() => setIsOpenApproveModal(false)}
      />
      <ModalReasonDenyLeave
        isOpen={isOpenRejectModal}
        onClose={() => setIsOpenRejectModal(false)}
        onSubmit={handleReject}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  )
}
